import { z } from 'zod';

export const VectorSchema = z.object({
  x: z.number(),
  y: z.number(),
});
export type Vector = z.infer<typeof VectorSchema>;

export const SizeSchema = z.object({
  width: z.number(),
  height: z.number(),
});
export type Size = z.infer<typeof SizeSchema>;

export const BoxSchema = z.object({
  type: z.literal('BOX'),
  position: VectorSchema,
  size: SizeSchema,
  rotation: z.number(),
  lockAspectRatio: z.boolean().optional(),
});
export type Box = z.infer<typeof BoxSchema>;

export const LineSchema = z.object({
  type: z.literal('LINE'),
  start: VectorSchema,
  end: VectorSchema,
});
export type Line = z.infer<typeof LineSchema>;

export const PinComponentLayoutSchema = z.discriminatedUnion('type', [BoxSchema, LineSchema]);
export type PinComponentLayout = z.infer<typeof PinComponentLayoutSchema>;

export const BasePinComponentSchema = z.object({
  id: z.string().min(1),
  layout: PinComponentLayoutSchema,
  order: z.string(),
});

export const BasePinComponentSettingsSchema = z.object({
  movableInInteractiveViewer: z.boolean().nullish(),
  lockLayout: z.boolean().nullish(),
});
